module.exports = __webpack_public_path__ + "static/media/multytecho.7cd20d92.pdf";